/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card[_ngcontent-%COMP%]{margin-bottom:0!important}.resum[_ngcontent-%COMP%]{position:absolute;left:85%;top:8vh;z-index:2;min-width:25vh}.filtreProv[_ngcontent-%COMP%]{position:absolute;left:71%;top:8vh;z-index:2;min-width:25vh}"];
export { styles as styles };
